import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from '../../../../state/app.state';
import { changeActiveSideTab, changeActiveTab, removeTab, setActiveTab } from '../../../../state/action';
import { selectActiveTabID, selectTabList } from '../../../../state/selectors';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class TabComponent implements OnInit, AfterViewInit {
  tabs$!: Observable<any[]>;
  activeTab$!: Observable<string>;
  @ViewChild('scroller') scrollerRef!: ElementRef<HTMLUListElement>;
  showLeftBtn = false;
  showRightBtn = false;

  constructor(private store: Store<AppState>,private router:Router) {}

  ngOnInit(): void {
    this.tabs$ = this.store.select(selectTabList);
    this.activeTab$ = this.store.select(selectActiveTabID);
    }

  onTabClick(tabId: string): void {
    this.store.dispatch(changeActiveTab({ tabId }));
    this.scrollActiveIntoView(tabId);
  }

  removeTab(tabId:string){
    this.store.dispatch(removeTab({tabId}));
  }

  trackByTabId(_: number, tab: any): string {
    return tab.tabId;
  }

  private scrollBy(distance: number): void {
    const el = this.scrollerRef?.nativeElement;
    if (!el) return;
    el.scrollBy({ left: distance, behavior: 'smooth' });
  }

  scrollLeft(): void {
    this.scrollBy(-220);
    setTimeout(() => this.checkScrollButtons(), 100);
  }

  scrollRight(): void {
    this.scrollBy(220);
    setTimeout(() => this.checkScrollButtons(), 100);
  }

  ngAfterViewInit(): void {
    this.activeTab$.subscribe(tabId => {
      setTimeout(() => {
        this.scrollActiveIntoView(tabId);
        this.checkScrollButtons();
      });
    });
    this.tabs$.subscribe(() => setTimeout(() => this.checkScrollButtons()));
  }

  checkScrollButtons(): void {
    const el = this.scrollerRef?.nativeElement;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    this.showLeftBtn = scrollLeft > 0;
    this.showRightBtn = scrollLeft < scrollWidth - clientWidth - 1;
  }

  private scrollActiveIntoView(tabId: string | null): void {
    if (!tabId) return;
    const container = this.scrollerRef?.nativeElement;
    if (!container) return;
    const el = container.querySelector(`button.tab[data-tabid="${tabId}"]`) as HTMLButtonElement | null;
    if (!el) return;

    const elLeft = el.offsetLeft;
    const elRight = elLeft + el.offsetWidth;
    const visibleLeft = container.scrollLeft;
    const visibleRight = visibleLeft + container.clientWidth;

    if (elLeft < visibleLeft) {
      container.scrollTo({ left: Math.max(0, elLeft - 16), behavior: 'smooth' });
    } else if (elRight > visibleRight) {
      container.scrollTo({ left: elRight - container.clientWidth + 16, behavior: 'smooth' });
    }
  }
}
